import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=71ed2de4&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=71ed2de4&prod&lang=scss"
import style1 from "./edit.vue?vue&type=style&index=1&id=71ed2de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed2de4",
  null
  
)

export default component.exports